module.exports = __webpack_public_path__ + "assets/img/welfare-img1-f58171bc.jpg";